import type { FaireProductEntity } from "../../entity_types/product";

export const p_rsd2f26c58: FaireProductEntity = {
  token: "p_rsd2f26c58",
  type: "product",
  name: "Life Force - Loose Leaf Herbal Tea",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/d632484c253efa42e1329fccafbece726698be406318babf13c9231f2ee4c842.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    " * Organic and Wild Crafted Herbs \n * Naturally Caffeine Free \n * Promotes Whole Body Rejuvenation \n * Loose leaf tea provides 40-60 servings \n\nRenew, Replenish, Rejuvenate! \n\n\nWith daily life being so busy and people always putting themselves last, we need a simple solution for rejuvenation. Our Life Force tea will bring you a new sense of energy and clarity and allow you to feel more present in your body all while detoxifying your system gently. Results you will feel right away!",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:56.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
